import { JournalStatus } from '../../../../entities/src/lib/enums/journal-status.enum';
import { Action, createReducer, on } from '@ngrx/store';
import * as TillStatusActions from './till-status.actions';

export const TILL_STATE_FEATURE_KEY = 'till-state';

export interface TillStatusState {
  loading: boolean;
  isUpdatingState: boolean;
  error?: string | null;
  previousStatusValue?: number | null;
  status: JournalStatus;
}

export interface TillStatusPartialState {
  readonly [TILL_STATE_FEATURE_KEY]: TillStatusState;
}

export const tillStatusInitialState: TillStatusState = {
  status: null,
  loading: false,
  isUpdatingState: false,
  error: null,
  previousStatusValue: null,
};

const tillStatusReducer = createReducer(
  tillStatusInitialState,
  on(TillStatusActions.loadTillStatus, (state) => {
    return { ...state, loading: true, error: null, isUpdatingState: false };
  }),
  on(
    TillStatusActions.setOpenCashPosition,
    TillStatusActions.closeCashPosition,
    (state) => {
      return { ...state, isUpdatingState: true, error: null };
    }
  ),
  on(TillStatusActions.loadTillStatusSuccess, (state, { payload }) => {
    return {
      ...state,
      ...payload,
      loading: false,
      error: null,
      isUpdatingState: false,
    };
  }),
  on(TillStatusActions.loadTillStatusFailure, (state, { error }) => {
    return { ...state, error, loading: false, isUpdatingState: false };
  }),
  on(TillStatusActions.clearTillStatus, (state) => {
    return tillStatusInitialState;
  })
);

export function createTillStatusReducer(
  state: TillStatusState | undefined,
  action: Action
) {
  return tillStatusReducer(state, action);
}
